// SUNDAY BATCH · FX2-2 — the red warning "Prior-year data exists - clear the first-year flag" (EN + AR from the server:
// first_year.PRIOR_DATA_CONFLICT_TEXT). Shown on the Validation screen (GET /fs/{id}/validation → first_year_conflict) and
// under the first-year toggle on Engagement settings (GET /engagements/{id}/first-year → conflict). Nothing when null.
import React from "react";
import { useI18n } from "@/contexts/I18nContext";

export default function FirstYearConflictNote({ conflict, testId = "first-year-conflict", className = "" }) {
  const { lang } = useI18n();
  if (!conflict || !conflict.text) return null;
  return (
    <div role="alert" data-testid={testId}
         className={`rounded border border-red-300 bg-red-50 px-3 py-1.5 text-xs font-semibold text-red-800 dark:border-red-900 dark:bg-red-950/30 dark:text-red-300 ${className}`}>
      {(lang === "ar" && conflict.text_ar) || conflict.text}
    </div>
  );
}
